import { render } from "./App.vue?vue&type=template&id=4e20921b"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4e20921b&lang=scss"
import "./App.vue?vue&type=style&index=1&id=4e20921b&lang=css"
script.render = render

export default script